<template>
    <b-row style="max-height: 100vh; overflow: hidden" class="row-principal">
        
        <b-col cols="12" class="contendedorPadre" lg="12" style="max-height: 100vh;" display>
            <!-- <div class="poligono">
                <div class="poli"></div>
            </div> -->

            <b-carousel
                    class="slider-gox"
                    ref="sliderGox"
                    id="carousel-1"
                    :interval="10000"
                    no-animation
                    indicators
                    style="text-shadow: 1px 1px 2px #333;"
            >

                <b-carousel-slide
                        v-for="(item, key) in content"
                        :key="key"
                        loading="lazy"
                        :img-src="srcImagen(item.imagen)"
                >
                    <div class="cuadroBlanco" :class="key == '1' ? 'pt-60':''">
                        <b-row>
                            <b-col class="col-10 mx-auto" >
                                <p class="slider-commerce-titulo" v-html="item.titulo"></p>
                                <p class="slider-commerce-contenido" v-html="item.contenido"></p>
                            </b-col>
                        </b-row>
                        
                    </div>
                    <!---->

                    <ol
                            v-if="key!==0 && key!==(content.length)-1"
                            id="carousel-2___BV_indicators_"
                            aria-hidden="false" aria-label="Select a slide to display"
                            aria-owns="carousel-2___BV_inner_"
                            class="carousel-indicators">
                        <li v-for="(item2, key2) in content"
                            :key="key2"
                            role="button"
                            :id="'carousel-2___BV_indicator_'+key+'_'"
                            tabindex="0"
                            :aria-current="key===key2? true: false"
                            :aria-label="'Goto Slide '+key2"
                            aria-controls="carousel-2___BV_inner_"
                            :class="key===key2? 'active': ''"
                            @click="setSlide(key2)"
                            aria-describedby="__BVID__140"></li>
                    </ol>
                </b-carousel-slide>
            </b-carousel>
        </b-col>

    </b-row>

 

</template>
<script>
    export default {
        name: 'section-slider',
        components: {},
        props: {
            content: Array
        },
        data: () => ({}),
        computed: {},
        mounted() {
        },
        methods: {
            goRouter(url) {
                this.$router.push(url)
            },
            srcImagen(img) {
                let src = require('@/assets/images/commerce_internal/' + img)
                return src
            },
            setSlide(index) {
                this.$refs.sliderGox.setSlide(index)
            }
        }
    }
</script>
<style scoped >
    /*#carousel-1 ::v-deep .carousel-indicators*/
        /*right: 7px*/
        /*bottom: 50%*/
        /*display: block*/
        /*margin-right: 0*/
        /*left: initial*/
        /*li*/
            /*margin-top: 10px !important*/
            /*width: 15px !important*/
    
      
    

    @media screen and (max-width: 600px) {


      }

    

</style>